// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "dataannotations/v1/dataannotations.proto" (package "dataannotations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data annotations RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalDataAnnotationsService } from "./dataannotations";
import type { RemoveClassificationFromBinaryDataByIDResponse } from "./dataannotations";
import type { RemoveClassificationFromBinaryDataByIDRequest } from "./dataannotations";
import type { GetLabelCountsForDatasetResponse } from "./dataannotations";
import type { GetLabelCountsForDatasetRequest } from "./dataannotations";
import type { RejectInferencesForJobResponse } from "./dataannotations";
import type { RejectInferencesForJobRequest } from "./dataannotations";
import type { ReviewInferencesResponse } from "./dataannotations";
import type { ReviewInferencesRequest } from "./dataannotations";
import type { GetCandidateInferencesResponse } from "./dataannotations";
import type { GetCandidateInferencesRequest } from "./dataannotations";
import type { SaveInferenceWithMetadataResponse } from "./dataannotations";
import type { SaveInferenceWithMetadataRequest } from "./dataannotations";
import type { BinaryDataByDatasetIDResponse } from "./dataannotations";
import type { BinaryDataByDatasetIDRequest } from "./dataannotations";
import type { GetTagsForOrgResponse } from "./dataannotations";
import type { GetTagsForOrgRequest } from "./dataannotations";
import type { AddTagsForResourceResponse } from "./dataannotations";
import type { AddTagsForResourceRequest } from "./dataannotations";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetBoundingBoxLabelsForOrgResponse } from "./dataannotations";
import type { GetBoundingBoxLabelsForOrgRequest } from "./dataannotations";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service dataannotations.v1.InternalDataAnnotationsService
 */
export interface IInternalDataAnnotationsServiceClient {
    /**
     * @generated from protobuf rpc: GetBoundingBoxLabelsForOrg(dataannotations.v1.GetBoundingBoxLabelsForOrgRequest) returns (dataannotations.v1.GetBoundingBoxLabelsForOrgResponse);
     */
    getBoundingBoxLabelsForOrg(input: GetBoundingBoxLabelsForOrgRequest, options?: RpcOptions): UnaryCall<GetBoundingBoxLabelsForOrgRequest, GetBoundingBoxLabelsForOrgResponse>;
    /**
     * @generated from protobuf rpc: AddTagsForResource(dataannotations.v1.AddTagsForResourceRequest) returns (dataannotations.v1.AddTagsForResourceResponse);
     */
    addTagsForResource(input: AddTagsForResourceRequest, options?: RpcOptions): UnaryCall<AddTagsForResourceRequest, AddTagsForResourceResponse>;
    /**
     * GetTagsForOrg gets the tags for a given organization_id based on the authenticated entity's permissions
     *
     * @generated from protobuf rpc: GetTagsForOrg(dataannotations.v1.GetTagsForOrgRequest) returns (dataannotations.v1.GetTagsForOrgResponse);
     */
    getTagsForOrg(input: GetTagsForOrgRequest, options?: RpcOptions): UnaryCall<GetTagsForOrgRequest, GetTagsForOrgResponse>;
    /**
     * @generated from protobuf rpc: BinaryDataByDatasetID(dataannotations.v1.BinaryDataByDatasetIDRequest) returns (dataannotations.v1.BinaryDataByDatasetIDResponse);
     */
    binaryDataByDatasetID(input: BinaryDataByDatasetIDRequest, options?: RpcOptions): UnaryCall<BinaryDataByDatasetIDRequest, BinaryDataByDatasetIDResponse>;
    /**
     * SaveInferenceWithMetadata saves the inference annotations along with metadata about the inference.
     * This defaults to marking the annotations as not accepted.
     *
     * @generated from protobuf rpc: SaveInferenceWithMetadata(dataannotations.v1.SaveInferenceWithMetadataRequest) returns (dataannotations.v1.SaveInferenceWithMetadataResponse);
     */
    saveInferenceWithMetadata(input: SaveInferenceWithMetadataRequest, options?: RpcOptions): UnaryCall<SaveInferenceWithMetadataRequest, SaveInferenceWithMetadataResponse>;
    /**
     * @generated from protobuf rpc: GetCandidateInferences(dataannotations.v1.GetCandidateInferencesRequest) returns (dataannotations.v1.GetCandidateInferencesResponse);
     */
    getCandidateInferences(input: GetCandidateInferencesRequest, options?: RpcOptions): UnaryCall<GetCandidateInferencesRequest, GetCandidateInferencesResponse>;
    /**
     * @generated from protobuf rpc: ReviewInferences(dataannotations.v1.ReviewInferencesRequest) returns (dataannotations.v1.ReviewInferencesResponse);
     */
    reviewInferences(input: ReviewInferencesRequest, options?: RpcOptions): UnaryCall<ReviewInferencesRequest, ReviewInferencesResponse>;
    /**
     * @generated from protobuf rpc: RejectInferencesForJob(dataannotations.v1.RejectInferencesForJobRequest) returns (dataannotations.v1.RejectInferencesForJobResponse);
     */
    rejectInferencesForJob(input: RejectInferencesForJobRequest, options?: RpcOptions): UnaryCall<RejectInferencesForJobRequest, RejectInferencesForJobResponse>;
    /**
     * @generated from protobuf rpc: GetLabelCountsForDataset(dataannotations.v1.GetLabelCountsForDatasetRequest) returns (dataannotations.v1.GetLabelCountsForDatasetResponse);
     */
    getLabelCountsForDataset(input: GetLabelCountsForDatasetRequest, options?: RpcOptions): UnaryCall<GetLabelCountsForDatasetRequest, GetLabelCountsForDatasetResponse>;
    /**
     * @generated from protobuf rpc: RemoveClassificationFromBinaryDataByID(dataannotations.v1.RemoveClassificationFromBinaryDataByIDRequest) returns (dataannotations.v1.RemoveClassificationFromBinaryDataByIDResponse);
     */
    removeClassificationFromBinaryDataByID(input: RemoveClassificationFromBinaryDataByIDRequest, options?: RpcOptions): UnaryCall<RemoveClassificationFromBinaryDataByIDRequest, RemoveClassificationFromBinaryDataByIDResponse>;
}
/**
 * @generated from protobuf service dataannotations.v1.InternalDataAnnotationsService
 */
export class InternalDataAnnotationsServiceClient implements IInternalDataAnnotationsServiceClient, ServiceInfo {
    typeName = InternalDataAnnotationsService.typeName;
    methods = InternalDataAnnotationsService.methods;
    options = InternalDataAnnotationsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetBoundingBoxLabelsForOrg(dataannotations.v1.GetBoundingBoxLabelsForOrgRequest) returns (dataannotations.v1.GetBoundingBoxLabelsForOrgResponse);
     */
    getBoundingBoxLabelsForOrg(input: GetBoundingBoxLabelsForOrgRequest, options?: RpcOptions): UnaryCall<GetBoundingBoxLabelsForOrgRequest, GetBoundingBoxLabelsForOrgResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBoundingBoxLabelsForOrgRequest, GetBoundingBoxLabelsForOrgResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddTagsForResource(dataannotations.v1.AddTagsForResourceRequest) returns (dataannotations.v1.AddTagsForResourceResponse);
     */
    addTagsForResource(input: AddTagsForResourceRequest, options?: RpcOptions): UnaryCall<AddTagsForResourceRequest, AddTagsForResourceResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddTagsForResourceRequest, AddTagsForResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetTagsForOrg gets the tags for a given organization_id based on the authenticated entity's permissions
     *
     * @generated from protobuf rpc: GetTagsForOrg(dataannotations.v1.GetTagsForOrgRequest) returns (dataannotations.v1.GetTagsForOrgResponse);
     */
    getTagsForOrg(input: GetTagsForOrgRequest, options?: RpcOptions): UnaryCall<GetTagsForOrgRequest, GetTagsForOrgResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTagsForOrgRequest, GetTagsForOrgResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BinaryDataByDatasetID(dataannotations.v1.BinaryDataByDatasetIDRequest) returns (dataannotations.v1.BinaryDataByDatasetIDResponse);
     */
    binaryDataByDatasetID(input: BinaryDataByDatasetIDRequest, options?: RpcOptions): UnaryCall<BinaryDataByDatasetIDRequest, BinaryDataByDatasetIDResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<BinaryDataByDatasetIDRequest, BinaryDataByDatasetIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * SaveInferenceWithMetadata saves the inference annotations along with metadata about the inference.
     * This defaults to marking the annotations as not accepted.
     *
     * @generated from protobuf rpc: SaveInferenceWithMetadata(dataannotations.v1.SaveInferenceWithMetadataRequest) returns (dataannotations.v1.SaveInferenceWithMetadataResponse);
     */
    saveInferenceWithMetadata(input: SaveInferenceWithMetadataRequest, options?: RpcOptions): UnaryCall<SaveInferenceWithMetadataRequest, SaveInferenceWithMetadataResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SaveInferenceWithMetadataRequest, SaveInferenceWithMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCandidateInferences(dataannotations.v1.GetCandidateInferencesRequest) returns (dataannotations.v1.GetCandidateInferencesResponse);
     */
    getCandidateInferences(input: GetCandidateInferencesRequest, options?: RpcOptions): UnaryCall<GetCandidateInferencesRequest, GetCandidateInferencesResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCandidateInferencesRequest, GetCandidateInferencesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReviewInferences(dataannotations.v1.ReviewInferencesRequest) returns (dataannotations.v1.ReviewInferencesResponse);
     */
    reviewInferences(input: ReviewInferencesRequest, options?: RpcOptions): UnaryCall<ReviewInferencesRequest, ReviewInferencesResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReviewInferencesRequest, ReviewInferencesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RejectInferencesForJob(dataannotations.v1.RejectInferencesForJobRequest) returns (dataannotations.v1.RejectInferencesForJobResponse);
     */
    rejectInferencesForJob(input: RejectInferencesForJobRequest, options?: RpcOptions): UnaryCall<RejectInferencesForJobRequest, RejectInferencesForJobResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RejectInferencesForJobRequest, RejectInferencesForJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLabelCountsForDataset(dataannotations.v1.GetLabelCountsForDatasetRequest) returns (dataannotations.v1.GetLabelCountsForDatasetResponse);
     */
    getLabelCountsForDataset(input: GetLabelCountsForDatasetRequest, options?: RpcOptions): UnaryCall<GetLabelCountsForDatasetRequest, GetLabelCountsForDatasetResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLabelCountsForDatasetRequest, GetLabelCountsForDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveClassificationFromBinaryDataByID(dataannotations.v1.RemoveClassificationFromBinaryDataByIDRequest) returns (dataannotations.v1.RemoveClassificationFromBinaryDataByIDResponse);
     */
    removeClassificationFromBinaryDataByID(input: RemoveClassificationFromBinaryDataByIDRequest, options?: RpcOptions): UnaryCall<RemoveClassificationFromBinaryDataByIDRequest, RemoveClassificationFromBinaryDataByIDResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveClassificationFromBinaryDataByIDRequest, RemoveClassificationFromBinaryDataByIDResponse>("unary", this._transport, method, opt, input);
    }
}
